import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArtaHero } from '../components/arta/ArtaHero';
import { ArtaProblem } from '../components/arta/ArtaProblem';
import { ArtaCurriculum } from '../components/arta/ArtaCurriculum';
import { ArtaBenefits } from '../components/arta/ArtaBenefits';
import { ArtaAbout } from '../components/arta/ArtaAbout';
import { ArtaForWho } from '../components/arta/ArtaForWho';
import { ArtaPricing } from '../components/arta/ArtaPricing';
import { ArtaTestimonials } from '../components/arta/ArtaTestimonials';
import { ArtaFAQ } from '../components/arta/ArtaFAQ';
export function ArtaPage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2271">
      <Header data-id="element-2272" />
      <main data-id="element-2273">
        <ArtaHero data-id="element-2274" />
        <ArtaProblem data-id="element-2275" />
        <ArtaCurriculum data-id="element-2276" />
        <ArtaBenefits data-id="element-2277" />
        <ArtaAbout data-id="element-2278" />
        <ArtaForWho data-id="element-2279" />
        <ArtaPricing data-id="element-2280" />
        <ArtaTestimonials data-id="element-2281" />
        <ArtaFAQ data-id="element-2282" />
      </main>
      <Footer data-id="element-2283" />
    </div>;
}